import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './neon-bite-food-Delivery.css';
import toDoListImage from '../../../assets/images/tapacademy.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Tap Academy <span>Clone</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 11th July 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">Tap Academy</h2>
          <span className="project-category">Website</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="tapAcademy" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://tap-academy-clone.netlify.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Tap-Academy-Clone" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "tapAcademy",
                title: "Tap Academy Clone",
                path: "/projects/projectdetail/tap-academy-clone"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
          Welcome to the <strong>TAP Academy Clone</strong>! Here's a detailed overview of the educational website and its features.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>TAP Academy Clone</strong> is a modern and responsive educational website inspired by TAP Academy. It recreates the overall user experience with a clean layout, engaging sections, and responsive design. The website showcases courses, placement information, testimonials, trainers, and contact details while demonstrating modern front-end development practices.
          </p>

          <h3 className="section-title">Key Features of the Website 🛠️</h3>
          <ul className="feature-list">
           <li><strong>Modern Hero Section</strong> 🚀 - Attractive landing page introducing TAP Academy.</li>
           <li><strong>Courses Section</strong> 📚 - Displays available technical courses with detailed information.</li>
           <li><strong>Placement Statistics</strong> 💼 - Highlights student placement success and achievements.</li>
           <li><strong>Expert Trainers</strong> 👨‍🏫 - Showcases experienced instructors and mentors.</li>
           <li><strong>Student Testimonials</strong> ⭐ - Displays feedback from successful students.</li>
           <li><strong>Responsive Navigation</strong> 📱 - Fully responsive navigation across all devices.</li>
           <li><strong>Contact Section</strong> 📞 - Easy access to academy contact information.</li>
          </ul>

          <h3 className="section-title">How the Website Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Explore Courses</strong> 📚 - Browse technical training programs.</li>
            <li><strong>Learn About Placements</strong> 💼 - View placement records and hiring partners.</li>
            <li><strong>Meet Trainers</strong> 👨‍🏫 - Learn about experienced faculty members.</li>
            <li><strong>Contact Academy</strong> 📞 - Reach out for admissions and enquiries.</li>
          </ul>

          <h3 className="section-title">Features and Benefits 🚀</h3>
          <ul className="benefits-list">
             <li><strong>Professional UI</strong> 🎨 - Clean and modern educational website design.</li>
             <li><strong>Responsive Experience</strong> 📱 - Optimized for mobile, tablet, and desktop devices.</li>
             <li><strong>Easy Navigation</strong> 🧭 - User-friendly layout for better accessibility.</li>
             <li><strong>Improved User Engagement</strong> ⭐ - Interactive sections and smooth animations.</li>
          </ul>

          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
                 <li><strong>Frontend</strong> 🖥️ - HTML5, CSS3, JavaScript (ES6).</li>
                 <li><strong>Animations</strong> ✨ - Framer Motion for smooth page transitions.</li>
                  <li><strong>Responsive Design</strong> 📱 - CSS Flexbox, Grid, and Media Queries.</li>
                  <li><strong>Deployment</strong> ☁️ - GitHub Pages / Netlify.</li>
          </ul>

          <h3 className="section-title">Real-Life Applications 🌍</h3>
          <ul className="real-life-applications-list">
            <li><strong>Educational Institutes</strong> 🎓 - College and academy websites.</li>
            <li><strong>Online Learning Platforms</strong> 💻 - Course presentation portals.</li>
            <li><strong>Training Centers</strong> 📚 - Technical training institute websites.</li>
            <li><strong>Corporate Learning</strong> 🏢 - Employee training platforms.</li>
          </ul>

          <h3 className="section-title">Future Features 🔮</h3>
          <ul className="future-features-list">
              <li><strong>Student Login</strong> 🔐 - Personalized student dashboard.</li>
              <li><strong>Course Enrollment</strong> 📝 - Online registration and admissions.</li>
              <li><strong>Learning Management System</strong> 🎥 - Video lectures and assignments.</li>
              <li><strong>Placement Portal</strong> 💼 - Job opportunities and interview tracking.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>The <strong>TAP Academy Clone</strong> demonstrates a professional educational website with a modern user interface, responsive design, course information, placement highlights, trainer profiles, and contact sections. This project showcases strong front-end development skills, clean UI implementation, responsive layouts, and interactive user experiences.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
